import React from 'react';

const getBrandingSrc = () => {
  const baseUrl = '/images/PoweredBy--gray.svg';
  switch (process.env.NODE_ENV) {
    case 'production':
      return `https://www.bookthatapp.com${baseUrl}`;
    case 'staging':
      return `https://www.bookthatapp-staging.com${baseUrl}`;
    default:
      return baseUrl;
  }
};
const BrandingString = () => (
    <p style={{ textAlign: 'right' }}>
        <a href="https://www.bookthatapp.com" target="_blank" rel="noreferrer">
          <img
              style={{ verticalAlign: 'bottom', marginBottom: -5 }}
              src={getBrandingSrc()}
              alt="Powered by BookThatApp" />
        </a>
    </p>
);

export default BrandingString;
